import styled from 'styled-components';
import { desktop_breakpoint } from 'pubweb-smokey/dist/components/GridSystem/_vars_widths.js';
import Colors from 'pubweb-smokey/dist/colors';

export const FeaturesStyles = styled.div`
  .features-heading {
    margin-bottom: 20px;
  }
  ul {
    list-style-type: none;

    li {
      display: flex;
      margin-bottom: 15px;

      .feature-tag-text {
        margin-top: 10px;
      }
      .feature-icon {
        margin-right: 10px;
      }
    }
  }

  @media only screen and (min-width: ${desktop_breakpoint}px) {
    .features-heading {
      border-bottom: solid 1px ${Colors.accent.grey5.standard};
      padding-bottom: 12px;
    }
    ul {
      display: flex;
      flex-wrap: wrap;

      li {
        margin-right: 2%;
        width: 30%;
      }
    }
  }
`;
